<div class="container">
  <div class="row date">

    <div class="col-md-6">

       <div class="col-md-6 form-group">
        <mat-form-field>
          <mat-label>{{ 'pages.jobsHnadover.selectDateFrom' | translate }}</mat-label>
          <input matInput [matDatepicker]="dateFrom">
          <mat-hint>{{ 'pages.jobsHnadover.dateHint' | translate }}</mat-hint>
          <mat-datepicker-toggle matIconSuffix [for]="dateFrom"></mat-datepicker-toggle>
          <mat-datepicker #dateFrom></mat-datepicker>
        </mat-form-field>
      </div>
     
      <div class="col-md-6 form-group">
       <mat-form-field>
          <mat-label>{{ 'pages.jobsHnadover.selectDateTo' | translate }}</mat-label>
          <input matInput [matDatepicker]="dateTo" >
          <mat-hint>{{ 'pages.jobsHnadover.dateHint' | translate }}</mat-hint>
          <mat-datepicker-toggle matIconSuffix [for]="dateTo"></mat-datepicker-toggle>
          <mat-datepicker #dateTo></mat-datepicker>
        </mat-form-field>
      </div>  
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <div class="col-md-6">
         <div class="form-group">
          <label>{{ 'pages.jobsHnadover.courierId' | translate }}</label>
          <div class="input-group" style="z-index: 0;">
            <input type="text" class="form-control"
                   [placeholder]="'pages.jobsHnadover.courierID' | translate"
                   [(ngModel)]="courierId">
            <span class="input-group-btn">
              <button class="btn  btn-primary" type="button" (click)="initlizeSearch()">{{ 'common.search' | translate }}</button>
            </span>
          </div> 
        </div>
      </div>
    </div>
  </div>
  <div class="row ">
    <div class="col-md-12">
      <div class="col-md-12">
        <div class="results">
          <div class="results-header">
            <label>{{ 'common.results' | translate }}</label>
          </div>
          <div class="results-body">
            <table class="table">
              <thead>
                <tr>
                  <th><b>{{ 'pages.jobsHnadover.jobReference' | translate }}</b></th>
                  <th><b>{{ 'pages.jobsHnadover.courierID' | translate }}</b></th>
                  <th><b>{{ 'pages.jobsHnadover.courierName' | translate }}</b></th>
                  <th><b>{{ 'pages.jobsHnadover.jobStatus' | translate }}</b></th>
                  <th><b>{{ 'pages.jobsHnadover.totalShipments' | translate }}</b></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of data">
                  <td>{{item.JobReference}}</td>
                  <td>{{item.CourierId}}</td>
                  <td>{{item.CourierName}}</td>
                  <td><span class="span-status {{item.JobStatus}}">{{item.JobStatus}}</span></td>
                  <td>{{item.TotalShipments}}</td>
                  <td><button class="btn btn-details" (click)="getSpotShipmentsDetails(item.CourierId,item.JobReference)" >{{ 'pages.jobsHnadover.shipmentsdetails' | translate }}</button></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <nav class="nav-pagination">
      <ul class="pagination">
        <li *ngIf="!(pagesContainer.length <=1) && (pagger != 0)"><button class="btn " (click)="prevPage()"><span class="armx-icon armx-left-dir"></span></button></li>
        <li *ngIf="!(pagesContainer.length <=1) && pagger >= 3"><button class="btn " (click)="getSearchPage(0)">1</button> ..</li>
        <li *ngFor="let a of pagesContainer; let index = index">
          <button *ngIf="((index == pagger) || (pagger <= index + 5) && (index > pagger - 3 && index < pagger + 5) ) && !(pagesContainer <=1)" (click)="getSearchPage(index)" class="btn  {{index == pagger ? 'active' : 'no'}}">{{index+1}}</button>
          {{index < pagger && index >= pagger+5 ? '.' : ''}}
          <button class="btn " *ngIf="index == pagesContainer.length" (click)="getSearchPage(pagger)">{{pagger + 1  }}</button>
        </li>
        <li *ngIf="!(pagesContainer.length <=1) && (pagger <= pagesContainer.length-6)">
          ..
          <button class="btn  {{pagesContainer.length == pagger ? 'active' : 'no'}}" (click)="getSearchPage(pagesContainer.length-1)">{{pagesContainer.length}}</button>
          <button class="btn " (click)="nextPage()"><a><span class="armx-icon armx-right-dir"></span></a></button>
        </li>
      </ul>
    </nav>
  </div>
</div>

<!-- Trigger the modal with a button -->
<button type="button" style="display:none" class="btn btn-info btn-lg" data-toggle="modal" data-target="#myModal" hidden="hidden" #modalbtn>{{ 'pages.jobsHnadover.openModal' | translate }}</button>

<!-- Modal -->
<div id="myModal" class="modal fade" role="dialog">
  <div class="modal-dialog">

    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h4 class="modal-title">{{ 'pages.jobsHnadover.shipmentsdetails' | translate }}</h4>
      </div>
      <div class="modal-body">
        <table class="table table-borderd">
          <thead>
            <tr>
              <th><b>{{ 'pages.jobsHnadover.shipmentNumber' | translate }}</b></th>
              <th><b>{{ 'pages.jobsHnadover.consigneeName' | translate }}</b></th>
              <th><b>{{ 'pages.jobsHnadover.physicalLocation' | translate }}</b></th>
            </tr>
          </thead>
          <tbody >
            <tr *ngFor="let item of shipmentsData">
              <td>{{item.shipmentNo}}</td>
              <td>{{item.ConsigneeName}}</td>
              <td>{{item.comments}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default" data-dismiss="modal">{{ 'common.close' | translate }}</button>
      </div>
    </div>

  </div>
</div>
